const SECTION_NAME = 'entrypoint_section';
export const FORM_NAME = 'rate_alerts_email_capture';
export const MODAL_ENTITY_NAME = 'acct_creation_rate_alerts_modal';
export const MODAL_SECTION_NAME = SECTION_NAME;
export const BUTTON_ENTITY_NAME = 'ep_acct_creation_rate_alerts_cta';
export const BUTTON_SECTION_NAME = SECTION_NAME;
export const CONTROL_ENTITY_NAME = 'ep_acc_creation_control';
export const CONTROL_SECTION_NAME = SECTION_NAME;
